export const FRUSTRUM_Z_MAX = 6000;
export const FRUSTRUM_Z_MIN = 1;
export const CAMERA_DEFAULT_POSITION_Z = 1000;
export const CAMERA_DEFAULT_ZOOM = 0.1;
export const FIT_VIEW_FACTOR = 1;
export const PINCH_FACTOR = 2;
